import { Button, TextField, Box, Alert, Typography, Autocomplete, FormControl } from "@mui/material";
import { useState, useEffect } from "react";
import CustomLoader from '../../../core/components/common/custom-loader.component';
import CustomFormSuccess from '../../../core/components/common/custom-form-success.component';
import PermissionService from "../services/api/permission-service";
import ModuleService from "../services/api/module-service";
import { useSnackbar } from "notistack";

const CreateFunctionForm = ({ handleClose, handleRecordChange, module, addPermission }) => {

    const [permissionName, setPermissionName] = useState('');
    const [moduleList, setModuleList] = useState([]);
    const [selectedModule, setSelectedModule] = useState(''); 
    const [description, setDescription] = useState('');
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const fetchData = () => {
        if(!module){ 
            ModuleService.listModules().then((res) => {
                let apiResponse = res.data;
                setModuleList(apiResponse.data);
            }).catch((error) => {
                const errorMessage = error?.response?.data?.error || error.message;
                enqueueSnackbar(errorMessage, {
                    variant: "error",
                    autoHideDuration: 2000
                });
            });
        } else {
            setModuleList([module]);
            setSelectedModule(module.id);
        }
    };


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSubmit = () => {
        setLoading(true);

        let payload = {
            module_id: selectedModule, 
            fn: permissionName,
            description: description
        };

        PermissionService.createPermission(payload).then((result) => {
            setLoading(false);
            setSuccess(true);
            if (addPermission) {
                addPermission(result.data);
            }
            handleRecordChange();

        }).catch((error) => {
            setLoading(false);
            setSuccess(false);
            setStatusCode(error.status);
            const errorMessage = error?.response?.data?.error || error?.response?.data?.error_message;
            setErrorMessage(errorMessage);
        });
    };

    return (
        <div>
            {loading ? (
                <CustomLoader />
            ) : (
                <div>
                    {success ? (
                        <CustomFormSuccess handleClose={handleClose} message={"Function was successfully created"} />
                    ) : (
                        <div>
                            {errorMessage && (
                                <Alert style={{ marginBottom: "12px" }} severity="error">
                                    {errorMessage}.
                                    <Typography sx={{ fontSize: '0.5rem' }}>
                                        Status Code: {statusCode}
                                    </Typography>
                                </Alert>
                            )}
                            <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        id="module-select"
                                        options={moduleList}
                                        getOptionLabel={(option) => option.module_name}
                                        value={selectedModule ? moduleList.find((item) => item.id === selectedModule) : null}
                                        onChange={(e, newValue) => setSelectedModule(newValue ? newValue.id : null)}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Module"
                                            variant="outlined"
                                        />
                                        )}
                                        disabled={!!module}
                                    />
                                </FormControl>

                                <TextField
                                    label="Function Name"
                                    variant="outlined"
                                    fullWidth
                                    value={permissionName}
                                    onChange={(e) => setPermissionName(e.target.value)}
                                />
                                
                                <TextField
                                    label="Description"
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    fullWidth
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                            </Box>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
export default CreateFunctionForm;
